import parsePrices from "functions/parseSWPrices";
import formatPrice from "functions/priceFormat";
import {makeStyles} from "@material-ui/styles";
import theme from "../../theme";
import {useTranslation} from "tools/i18n";
import React from "react";

const useStyles = makeStyles(() => ({
	prices: {
		display: 'flex',
		alignItems: 'baseline',
		alignSelf: 'flex-start',
		marginTop: 5,
		marginBottom: 0,
		paddingTop: 5,
	},
	price: {
		...theme.typography.productPrice,
		fontFamily: 'Sterling, "Open Sans", sans-serif',
		fontSize: 22,
		color: '#000',
		'&.special': {
			color: '#d92e3f'
		},
		'&.old': {
			marginLeft: 6,
			fontSize: "inherit",
			fontWeight: 400,
			color: '#000000'
		},
		[theme.breakpoints.up('md')]: {
			fontSize: 24
		}
	},
	originally: {
		marginLeft: 8,
		fontFamily: 'Sterling, "Open Sans", sans-serif',
		fontSize: 14,
		fontWeight: 400,
		lineHeight: 1,
		color: '#000000',
		[theme.breakpoints.up('md')]: {
			fontSize: 17
		}
	},
	discount: {
		marginLeft: 6,
		...theme.typography.productPrice,
		fontSize: "inherit",
		color: '#d92e3f',
		fontWeight: 400
	}
}), {name: 'ProductPrice'});

export default function ProductPrice({product}) {
	const classes = useStyles();
	const {t} = useTranslation('product-info');
	const prices = parsePrices(product.calculatedPrices && product.calculatedPrices.length > 0 ? product.calculatedPrices[0] : product.calculatedPrice);

	return (
		<div className={classes.prices}>
			{prices.isOnSale ?
				<>
					<span className={[classes.price, 'special'].join(' ')}>{formatPrice(prices.price)}</span>
					<span className={classes.originally}>
						{t('price-originally')}
						<span className={[classes.price, 'old'].join(' ')}>{formatPrice(prices.listPrice)}</span>
						{prices.discount && false ?
									<span className={classes.discount}>-{Math.floor(prices.discount.percentage)}%</span> : ''}
					</span>
				</> : <span className={classes.price}>{formatPrice(prices.price)}</span>
			}
		</div>
	);
}
